import type { ReactNode } from 'react';
import { styled } from 'styled-components';

import { colors, transition } from '#/theme/theme';

const RadioContainer = styled.div<{ $noMinHeight: boolean }>`
  display: inline-flex;
  ${(props) => (props.$noMinHeight ? '' : 'min-height: 35px;')};
`;
const StyledLabel = styled.label<{ $color: string }>`
  font-size: 18px;
  color: ${(props) => props.$color};
  padding-left: 11px;
  cursor: pointer;
`;
const StyledRadio = styled.input`
  background-color: ${colors.white};
  height: 16px;
  width: 16px;
  min-width: 16px;
  border: solid 1px ${colors.lightContentGrey};
  border-radius: 50%;
  padding: 3px;
  cursor: pointer;
  margin: 4px 0 3px;
  transition: all ${transition};

  && {
    appearance: none;
  }

  &:checked {
    background-clip: content-box;
    background-color: ${colors.brandBlue};
  }

  &:focus {
    border-color: ${colors.brandBlue};
    box-shadow: 0 0 0 1px ${colors.brandBlue};
    outline: 0;
  }

  &[disabled] {
    background: ${colors.elementGrey};
    opacity: 0.5;
    cursor: default;

    + label {
      color: #aaa;
      cursor: default;
    }
  }
`;

type Props = {
  qaId?: string;
  disabled?: boolean;
  id?: string;
  name?: string;
  value: string | boolean | number;
  label: ReactNode;
  checked: boolean;
  onClick?: () => void;
  onChange: (value: string | boolean | number) => void;
  required?: boolean;
  noMinHeight?: boolean;
  color?: string;
};

export function RadioButton({
  qaId,
  id,
  name,
  value,
  label,
  checked,
  disabled,
  required,
  noMinHeight,
  color = colors.lightContentGrey,
  onChange,
  onClick,
}: Props) {
  return (
    <RadioContainer $noMinHeight={Boolean(noMinHeight)}>
      <StyledRadio
        type="radio"
        name={name}
        id={id}
        checked={checked}
        disabled={disabled}
        required={required}
        value={typeof value === 'string' ? value : value.toString()}
        onChange={(e) => {
          e.stopPropagation();

          if (onChange) {
            onChange(value);
          }
        }}
        onClick={onClick}
        data-qa-id={qaId}
      />
      <StyledLabel htmlFor={id} $color={color}>
        {label}
      </StyledLabel>
    </RadioContainer>
  );
}
